import Auth from 'j-toker';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { isValidEmail } from 'helpers/Validator';
import ERROR_TRANSLATIONS from 'constants/tenantApplicationErrorTranslations.constants';

const validate = (values) => {
  const errors = {};

  if (!values.cotenants || !values.cotenants.length) {
    errors.cotenants = {
      _error: ERROR_TRANSLATIONS.cotenant.required(),
    };
  } else {
    const cotenantsArrayErrors = [];
    values.cotenants.forEach((cotenant, cotenantIndex) => {
      const cotenantErrors = {};
      const parseResult = cotenant.phoneNumber && parsePhoneNumberFromString(cotenant.phoneNumber);
      if (!cotenant || !cotenant.firstName) {
        cotenantErrors.firstName = ERROR_TRANSLATIONS.required();
        cotenantsArrayErrors[cotenantIndex] = cotenantErrors;
      }
      if (!cotenant || !cotenant.lastName) {
        cotenantErrors.lastName = ERROR_TRANSLATIONS.required();
        cotenantsArrayErrors[cotenantIndex] = cotenantErrors;
      }
      if (!cotenant || !cotenant.guarantor) {
        cotenantErrors.guarantor = ERROR_TRANSLATIONS.required();
        cotenantsArrayErrors[cotenantIndex] = cotenantErrors;
      }
      if (!cotenant || !cotenant.phoneNumber) {
        cotenantErrors.phoneNumber = ERROR_TRANSLATIONS.required();
        cotenantsArrayErrors[cotenantIndex] = cotenantErrors;
      } else if (
        cotenant.phoneNumber.replace(/\s/g, '') !== '+00000000000' &&
        (!parseResult || !parseResult.isValid())
      ) {
        cotenantErrors.phoneNumber = ERROR_TRANSLATIONS.inValidPhoneNumber();
        cotenantsArrayErrors[cotenantIndex] = cotenantErrors;
      }
      if (!cotenant || !cotenant.email) {
        cotenantErrors.email = ERROR_TRANSLATIONS.required();
        cotenantsArrayErrors[cotenantIndex] = cotenantErrors;
      } else if (!isValidEmail(cotenant.email)) {
        cotenantErrors.email = ERROR_TRANSLATIONS.inValidEmail();
        cotenantsArrayErrors[cotenantIndex] = cotenantErrors;
      } else if (cotenant.email.toLowerCase() === Auth.user.email.toLowerCase()) {
        cotenantErrors.email = ERROR_TRANSLATIONS.cotenant.dupEmail();
        cotenantsArrayErrors[cotenantIndex] = cotenantErrors;
      }
    });
    if (cotenantsArrayErrors.length) {
      errors.cotenants = cotenantsArrayErrors;
    }
  }

  if (!values.occupants || !values.occupants.length) {
    errors.occupants = {
      _error: ERROR_TRANSLATIONS.occupant.required(),
    };
  } else {
    const occupantsArrayErrors = [];
    if (occupantsArrayErrors.length) {
      errors.occupants = occupantsArrayErrors;
    }
  }

  if (!values.vehicles || !values.vehicles.length) {
    errors.vehicles = {
      _error: ERROR_TRANSLATIONS.vehicle.required(),
    };
  } else {
    const vehiclesArrayErrors = [];
    values.vehicles.forEach((vehicle, vehicleIndex) => {
      const vehicleErrors = {};
      if (!vehicle || !vehicle.make) {
        vehicleErrors.make = ERROR_TRANSLATIONS.required();
        vehiclesArrayErrors[vehicleIndex] = vehicleErrors;
      }
      if (!vehicle || !vehicle.vehicle_type) {
        vehicleErrors.vehicle_type = ERROR_TRANSLATIONS.required();
        vehiclesArrayErrors[vehicleIndex] = vehicleErrors;
      }
      if (!vehicle || !vehicle.color) {
        vehicleErrors.color = ERROR_TRANSLATIONS.required();
        vehiclesArrayErrors[vehicleIndex] = vehicleErrors;
      }
      if (!vehicle || !vehicle.vehicle_plate_number) {
        vehicleErrors.vehicle_plate_number = ERROR_TRANSLATIONS.required();
        vehiclesArrayErrors[vehicleIndex] = vehicleErrors;
      }
    });
    if (vehiclesArrayErrors.length) {
      errors.vehicles = vehiclesArrayErrors;
    }
  }

  if (!values.tenant_pets || !values.tenant_pets.length) {
    errors.tenant_pets = {
      _error: ERROR_TRANSLATIONS.pet.required(),
    };
  } else {
    const petsArrayErrors = [];
    values.tenant_pets.forEach((pet, petIndex) => {
      const petErrors = {};
      if (!pet || !pet.breed) {
        petErrors.breed = ERROR_TRANSLATIONS.required();
        petsArrayErrors[petIndex] = petErrors;
      }
      if (!pet || !pet.name) {
        petErrors.name = ERROR_TRANSLATIONS.required();
        petsArrayErrors[petIndex] = petErrors;
      }
      if (!pet || !pet.weight) {
        petErrors.weight = ERROR_TRANSLATIONS.required();
        petsArrayErrors[petIndex] = petErrors;
      }
      if (!pet || !pet.distinctive_markings) {
        petErrors.distinctive_markings = ERROR_TRANSLATIONS.required();
        petsArrayErrors[petIndex] = petErrors;
      }
    });
    if (petsArrayErrors.length) {
      errors.tenant_pets = petsArrayErrors;
    }
  }

  if (!values.agreeToTerms) {
    errors.agreeToTerms = ERROR_TRANSLATIONS.terms();
  }
  if (!values.agreeToInstructionsTerms) {
    errors.agreeToInstructionsTerms = ERROR_TRANSLATIONS.instructionsTerms();
  }
  if (!values.lastName) {
    errors.lastName = ERROR_TRANSLATIONS.required();
  }
  if (!values.name) {
    errors.lastName = ERROR_TRANSLATIONS.required();
  }
  if (!values.paymentAmount) {
    errors.paymentAmount = ERROR_TRANSLATIONS.required();
  }
  if (!values.cardHolderName) {
    errors.cardHolderName = ERROR_TRANSLATIONS.required();
  }
  if (!values.reason_for_moving) {
    errors.reason_for_moving = ERROR_TRANSLATIONS.required();
  }
  if (!values.dob) {
    errors.dob = ERROR_TRANSLATIONS.required();
  }
  if (!values.monthlySalary) {
    errors.monthlySalary = ERROR_TRANSLATIONS.required();
  }
  if (!values.phoneNumber) {
    errors.phoneNumber = ERROR_TRANSLATIONS.required();
  }
  if (!values.hasPriorExperience) {
    errors.hasPriorExperience = ERROR_TRANSLATIONS.required();
  }
  if (!values.hasPreviouslyRented) {
    errors.hasPreviouslyRented = ERROR_TRANSLATIONS.required();
  }
  if (!values.evicted) {
    errors.evicted = ERROR_TRANSLATIONS.required();
  }
  if (!values.tenantHearing) {
    errors.tenantHearing = ERROR_TRANSLATIONS.required();
  }
  if (!values.crime) {
    errors.crime = ERROR_TRANSLATIONS.required();
  }
  if (!values.bankruptcy) {
    errors.bankruptcy = ERROR_TRANSLATIONS.required();
  }
  if (!values.hasCotenant) {
    errors.hasCotenant = ERROR_TRANSLATIONS.required();
  }
  if (!values.has_pets) {
    errors.has_pets = ERROR_TRANSLATIONS.required();
  }
  if (!values.has_vehicle) {
    errors.has_vehicle = ERROR_TRANSLATIONS.required();
  }
  if (!values.otherOccupants) {
    errors.otherOccupants = ERROR_TRANSLATIONS.required();
  }
  if (!values.street) {
    errors.street = ERROR_TRANSLATIONS.required();
  }
  if (!values.city) {
    errors.city = ERROR_TRANSLATIONS.required();
  }
  if (!values.province) {
    errors.province = ERROR_TRANSLATIONS.required();
  }
  if (!values.country) {
    errors.country = ERROR_TRANSLATIONS.required();
  }
  if (!values.postalCode) {
    errors.postalCode = ERROR_TRANSLATIONS.required();
  }
  if (!values.student) {
    errors.student = ERROR_TRANSLATIONS.required();
  }

  if (!values.university) {
    errors.university = ERROR_TRANSLATIONS.required();
  }
  if (!values.fieldOfStudy) {
    errors.fieldOfStudy = ERROR_TRANSLATIONS.required();
  }
  if (!values.universityCity) {
    errors.universityCity = ERROR_TRANSLATIONS.required();
  }
  if (!values.universityCountry) {
    errors.universityCountry = ERROR_TRANSLATIONS.required();
  }
  if (!values.graduatingYear) {
    errors.graduatingYear = ERROR_TRANSLATIONS.required();
  }

  if (!values.occupation) {
    errors.occupation = ERROR_TRANSLATIONS.required();
  }
  if (!values.companyName) {
    errors.companyName = ERROR_TRANSLATIONS.required();
  }
  if (!values.companyStreet) {
    errors.companyStreet = ERROR_TRANSLATIONS.required();
  }
  if (!values.companyCity) {
    errors.companyCity = ERROR_TRANSLATIONS.required();
  }
  if (!values.companyCountry) {
    errors.companyCountry = ERROR_TRANSLATIONS.required();
  }
  if (!values.companyProvince) {
    errors.companyProvince = ERROR_TRANSLATIONS.required();
  }
  if (!values.companyPostalCode) {
    errors.companyPostalCode = ERROR_TRANSLATIONS.required();
  }
  if (!values.startDate) {
    errors.startDate = ERROR_TRANSLATIONS.required();
  }
  if (!values.yearlySalary) {
    errors.yearlySalary = ERROR_TRANSLATIONS.required();
  }
  if (!values.yearly_income) {
    errors.yearly_income = ERROR_TRANSLATIONS.required();
  }
  if (values.sinNumber) {
    if (values.sinNumber.replace(/\D/g, '').length !== 9) {
      errors.sinNumber = ERROR_TRANSLATIONS.inValidSin();
    }
  }

  if (values.incomeProofType) {
    if (!values.proofOfIncome || values.proofOfIncome.length === 0)
      errors.proofOfIncome = ERROR_TRANSLATIONS.required();
  }

  if (values.proofOfIncome && values.proofOfIncome.length === 1) {
    if (!values.incomeProofType) errors.incomeProofType = ERROR_TRANSLATIONS.required();
  }
  if (!values.previousOccupation) {
    errors.previousOccupation = ERROR_TRANSLATIONS.required();
  }
  if (!values.previousCompanyName) {
    errors.previousCompanyName = ERROR_TRANSLATIONS.required();
  }
  if (!values.previousCompanyStreet) {
    errors.previousCompanyStreet = ERROR_TRANSLATIONS.required();
  }
  if (!values.previousCompanyCity) {
    errors.previousCompanyCity = ERROR_TRANSLATIONS.required();
  }
  if (!values.previousCompanyProvince) {
    errors.previousCompanyProvince = ERROR_TRANSLATIONS.required();
  }
  if (!values.previousCompanyPostalCode) {
    errors.previousCompanyPostalCode = ERROR_TRANSLATIONS.required();
  }
  if (!values.previousCompanyCountry) {
    errors.previousCompanyCountry = ERROR_TRANSLATIONS.required();
  }
  if (!values.previousStartDate) {
    errors.previousStartDate = ERROR_TRANSLATIONS.required();
  }
  if (!values.previousEndDate) {
    errors.previousEndDate = ERROR_TRANSLATIONS.required();
  }

  if (!values.idProofFiles || values.idProofFiles.length <= 0) {
    errors.idProofFiles = ERROR_TRANSLATIONS.required();
  }
  if (!values.idIncomeFiles || values.idIncomeFiles.length <= 0) {
    errors.idIncomeFiles = ERROR_TRANSLATIONS.required();
  }

  if (!values.voidChequeImage || values.voidChequeImage === 0) {
    errors.voidChequeImage = ERROR_TRANSLATIONS.required();
  }

  if (values.previousStartDate >= values.previousEndDate) {
    errors.previousStartDate = ERROR_TRANSLATIONS.previousStartDate();
    errors.previousEndDate = ERROR_TRANSLATIONS.previousEndDate();
  }

  if (!values.previousCompanySalary) {
    errors.previousCompanySalary = ERROR_TRANSLATIONS.required();
  }

  if (!values.emergency_contacts || !values.emergency_contacts.length) {
    errors.emergency_contacts = {
      _error: ERROR_TRANSLATIONS.emergencyContact.required(),
    };
  }

  if (
    !values.apply_in_person &&
    (!values.landlordReferences || !values.landlordReferences.length)
  ) {
    errors.landlordReferences = {
      _error: ERROR_TRANSLATIONS.landlordReference.required(),
    };
  } else if (values.landlordReferences && values.landlordReferences.length > 0) {
    const landlordReferenceArrayErrors = [];
    values.landlordReferences.forEach((landlordReference, landlordReferenceIndex) => {
      const landlordReferenceErrors = {};
      const parseResult =
        landlordReference.landlordPhoneNumber &&
        parsePhoneNumberFromString(landlordReference.landlordPhoneNumber);
      if (!landlordReference || !landlordReference.landlordName) {
        landlordReferenceErrors.landlordName = ERROR_TRANSLATIONS.required();
        landlordReferenceArrayErrors[landlordReferenceIndex] = landlordReferenceErrors;
      }
      if (!landlordReference || !landlordReference.landlordEmail) {
        landlordReferenceErrors.landlordEmail = ERROR_TRANSLATIONS.required();
        landlordReferenceArrayErrors[landlordReferenceIndex] = landlordReferenceErrors;
      } else if (!isValidEmail(landlordReference.landlordEmail)) {
        landlordReferenceErrors.landlordEmail = ERROR_TRANSLATIONS.inValidEmail();
        landlordReferenceArrayErrors[landlordReferenceIndex] = landlordReferenceErrors;
      } else if (landlordReference.landlordEmail.toLowerCase() === Auth.user.email.toLowerCase()) {
        landlordReferenceErrors.landlordEmail = ERROR_TRANSLATIONS.landlordReference.dupEmail();
        landlordReferenceArrayErrors[landlordReferenceIndex] = landlordReferenceErrors;
      }

      if (!landlordReference || !landlordReference.landlordPhoneNumber) {
        landlordReferenceErrors.landlordPhoneNumber = ERROR_TRANSLATIONS.required();
        landlordReferenceArrayErrors[landlordReferenceIndex] = landlordReferenceErrors;
      } else if (
        landlordReference.landlordPhoneNumber.replace(/\s/g, '') !== '+00000000000' &&
        (!parseResult || !parseResult.isValid())
      ) {
        landlordReferenceErrors.landlordPhoneNumber = ERROR_TRANSLATIONS.inValidPhoneNumber();
        landlordReferenceArrayErrors[landlordReferenceIndex] = landlordReferenceErrors;
      }
      if (!landlordReference || !landlordReference.lengthOfStay) {
        landlordReferenceErrors.lengthOfStay = ERROR_TRANSLATIONS.required();
        landlordReferenceArrayErrors[landlordReferenceIndex] = landlordReferenceErrors;
      }
      if (!landlordReference || !landlordReference.landlordMonthlyRent) {
        landlordReferenceErrors.landlordMonthlyRent = ERROR_TRANSLATIONS.required();
        landlordReferenceArrayErrors[landlordReferenceIndex] = landlordReferenceErrors;
      }
      if (!landlordReference || !landlordReference.landlordIsCurrentReference) {
        landlordReferenceErrors.landlordIsCurrentReference = ERROR_TRANSLATIONS.required();
        landlordReferenceArrayErrors[landlordReferenceIndex] = landlordReferenceErrors;
      }
    });
    if (landlordReferenceArrayErrors.length) {
      errors.landlordReferences = landlordReferenceArrayErrors;
    }
  }

  if (!values.personalReferences || !values.personalReferences.length) {
    return errors;
  } else {
    const personalReferencesArrayErrors = [];
    values.personalReferences.forEach((personalReferences, personalReferencesIndex) => {
      const parseResult =
        personalReferences.personalReferencePhoneNumber &&
        parsePhoneNumberFromString(personalReferences.personalReferencePhoneNumber);
      const personalReferencesErrors = {};
      if (!personalReferences || !personalReferences.personalReferenceName) {
        personalReferencesErrors.personalReferenceName = ERROR_TRANSLATIONS.required();
        personalReferencesArrayErrors[personalReferencesIndex] = personalReferencesErrors;
      } else if (personalReferences.personalReferenceName.split(' ').length < 2) {
        personalReferencesErrors.personalReferenceName =
          ERROR_TRANSLATIONS.personalReference.fullName();
        personalReferencesArrayErrors[personalReferencesIndex] = personalReferencesErrors;
      }
      if (!personalReferences || !personalReferences.personalReferenceEmail) {
        personalReferencesErrors.personalReferenceEmail = ERROR_TRANSLATIONS.required();
        personalReferencesArrayErrors[personalReferencesIndex] = personalReferencesErrors;
      } else if (!isValidEmail(personalReferences.personalReferenceEmail)) {
        personalReferencesErrors.personalReferenceEmail = ERROR_TRANSLATIONS.inValidEmail();
        personalReferencesArrayErrors[personalReferencesIndex] = personalReferencesErrors;
      } else if (
        personalReferences.personalReferenceEmail.toLowerCase() === Auth.user.email.toLowerCase()
      ) {
        personalReferencesArrayErrors.personalReferenceEmail =
          ERROR_TRANSLATIONS.personalReference.dupEmail();
        personalReferencesArrayErrors[personalReferencesIndex] = personalReferencesErrors;
      }
      if (!personalReferences || !personalReferences.personalReferencePhoneNumber) {
        personalReferencesErrors.personalReferencePhoneNumber = ERROR_TRANSLATIONS.required();
        personalReferencesArrayErrors[personalReferencesIndex] = personalReferencesErrors;
      } else if (
        personalReferences.personalReferencePhoneNumber.replace(/\s/g, '') !== '+00000000000' &&
        (!parseResult || !parseResult.isValid())
      ) {
        personalReferencesErrors.personalReferencePhoneNumber =
          ERROR_TRANSLATIONS.inValidPhoneNumber();
        personalReferencesArrayErrors[personalReferencesIndex] = personalReferencesErrors;
      }
      if (!personalReferences || !personalReferences.relationshipType) {
        personalReferencesErrors.relationshipType = ERROR_TRANSLATIONS.required();
        personalReferencesArrayErrors[personalReferencesIndex] = personalReferencesErrors;
      }
      if (!personalReferences || !personalReferences.relationshipDuration) {
        personalReferencesErrors.relationshipDuration = ERROR_TRANSLATIONS.required();
        personalReferencesArrayErrors[personalReferencesIndex] = personalReferencesErrors;
      }
    });
    if (personalReferencesArrayErrors.length) {
      errors.personalReferences = personalReferencesArrayErrors;
    }
  }

  return errors;
};

export default validate;
